import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SafeHtml, SafeUrl, SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Select2OptionData } from 'ng2-select2';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { TransactionReq } from 'src/app/enums/apiRequest';
import { RespCode, SessionVar } from 'src/app/enums/emums';
import { ApidataService } from 'src/app/services/apidata.service';
import { ApiService } from 'src/app/services/apiservices.service';
import { AuthService } from 'src/app/services/auth.service';
import { FormValidationService } from 'src/app/services/form-validation.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'aditya-wallet-load',
  templateUrl: './wallet-load.component.html',
  styleUrls: ['./wallet-load.component.css']
})
export class WalletLoadComponent implements OnInit {
  RechargeForm: FormGroup;
  IsRechargeSubmitted: boolean = false;
  mobile: number;
  amount: number;
  spnmobile = '';
  spnamount = '';
  IsbannerShow = true;
  IsMobileValid = false;
  slides = [];
  odata: any;
  slideConfig = { "slidesToShow": 1, "slidesToScroll": 1, autoplay: false, autoplaySpeed: 2000, arrows: true };
  public operator = 0;
  public OperatorData: Array<Select2OptionData>;
  public filteredOperator: Observable<Array<Select2OptionData>>;

  constructor(
    private fb: FormBuilder,
    private apiData: ApidataService,
    private router: Router,
    private authService: AuthService,
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private FormValidation: FormValidationService,
    private loaderService: LoaderService,
    protected _sanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    this.loaderService.show();
    this.RechargeForm = this.fb.group({
      mobile: this.fb.control('', [Validators.required]),
      amount: this.fb.control('', [Validators.required]),
      myControl: this.fb.control({ text: 'Select Operator' }), // placeholder value
    });

    this.OperatorData = this.apiData.getOperator(this.apiData.getRouteID(this.router.url.replace('/', '').replace('.html', '')));
    this.GetB2CBanner();

    this.filteredOperator = this.RechargeForm.controls['myControl'].valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterOperator(value))
      );

    // this.checkShowBanner();

    this.apiService.GetNumberList().subscribe(resp => {
      if (resp && resp.statuscode == RespCode.Success) {
        this.apiData.setSessionData(SessionVar.BaseData, resp.data);
        localStorage.setItem(SessionVar.BaseData, JSON.stringify(resp.data))

        this.OperatorData = this.apiData.getOperator(this.apiData.getRouteID(this.router.url.replace('/', '').replace('.html', '')));

        this.filteredOperator = this.RechargeForm.controls['myControl'].valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterOperator(value))
          );
      }
      this.loaderService.hide();
    });
  }

  get w() { return this.RechargeForm.controls || '' }

  transform(value: string, type?: string): SafeHtml | SafeUrl | SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustUrl(value);
  }

  Operatorchangednew(event: any): void {
    this.operator = parseInt(event.option.value.id);
    this.odata = this.apiData.getOperatorData(this.operator);
    this.RechargeForm.controls['mobile'].setValidators([Validators.minLength(this.odata.length), Validators.maxLength(this.odata.lengthMax)]);
    this.RechargeForm.controls['amount'].setValidators([Validators.min(this.odata.min), Validators.max(this.odata.max), Validators.pattern('^[0-9]+(\\.[0-9]+)?$')]);
    this.IsRechargeSubmitted = false;
  }

  public displayFn(data?: Select2OptionData): string {
    return data ? data.text : '';
  }

  private _filterOperator(object: any): Array<Select2OptionData> {
    let value = typeof (object) === 'object' ? object.text : object;
    if (value != null && value != "") {
      var filterValue = value.toLowerCase();
      var data = this.OperatorData.filter(operator => operator.text.toLowerCase().includes(filterValue))
      return data;
    }
    else
      return this.OperatorData;
  }

  inputclear() {
    this.operator = 0;
    this.RechargeForm.controls['myControl'].setValue(' ');
  }

  checkOperator() {
    this.validateMobile();
    var req = { mobile: "", userID: "" };
    const prevMobile = this.mobile;
    this.IsMobileValid = false;
    if (this.mobile) {
      req.mobile = this.mobile.toString();
      if (this.mobile.toString().length == 10) {
        var id = this.authService.getUserID();
        if (!id) {
          return;
        }
        req.userID = id;
        this.apiService.GetWalletLoadLookup(req).subscribe((resp: any) => {
          if (resp && resp.statuscode == 1 && resp.email) {
            if (this.mobile == prevMobile) {
              this.IsMobileValid = true;
            } else {
              this.IsMobileValid = false;
            }
          }
        });
      }
    }
  }

  validateMobile() {
    if (this.FormValidation.CheckFormValidStatus(this.RechargeForm)) {
      if (this.FormValidation.checkControlValidation("mobile")) {
        if (this.FormValidation.RequiredValidation("mobile")) {
          this.spnmobile = "Mobile no. is required";
        }
        else if (this.FormValidation.checkLength("mobile")) {
          this.spnmobile = "Invalid Mobile no.";
        }
        else if (this.FormValidation.checkPattern("mobile") && this.odata.isAccountNumeric) {
          this.spnmobile = "Invalid mobile no.";
        } else {
          this.spnmobile = "";
        }
      }
    }
    if (!this.mobile) {
      this.spnmobile = "Mobile no. is required";
      return;
    }
  }

  proceedToAction() {
    this.IsRechargeSubmitted = true;
    if (this.FormValidation.CheckFormValidStatus(this.RechargeForm)) {
      if (this.FormValidation.checkControlValidation("mobile")) {
        if (this.FormValidation.RequiredValidation("mobile")) {
          this.spnmobile = "Mobile no. is required";
        }
        else if (this.FormValidation.checkLength("mobile")) {
          this.spnmobile = "Invalid Mobile no.";
        }
        else if (this.FormValidation.checkPattern("mobile") && this.odata.isAccountNumeric) {
          this.spnmobile = "Invalid mobile no.";
        }
      }
      if (this.FormValidation.checkControlValidation("amount")) {
        if (this.FormValidation.RequiredValidation("amount")) {
          this.spnamount = "Amount is required";
        }
        else if (this.FormValidation.checkMinMaxAmount("amount")) {
          this.spnamount = "Amount should be between " + this.odata.min + " to " + this.odata.max;
        }
        else if (this.FormValidation.checkPattern("amount")) {
          this.spnamount = "Invalid amount";
        }
      }
      if (this.odata && this.mobile) {
        if (this.odata.length > this.mobile.toString().length) {
          this.spnmobile = "Invalid Mobile no.";
        }
      }
      return;
    }
    if (!this.mobile) {

      this.spnmobile = "Mobile no. is required";
      return;
    }
    if (!this.amount) {
      this.spnamount = "Amount is required";

      return;
    }
    this.spnmobile = "";
    this.spnamount = "";

    var transactionReq: TransactionReq = {
      accountNo: this.mobile,
      amount: this.amount,
      customerNo: '',
      geoCode: '',
      o1: '',
      o2: '',
      o3: '',
      o4: '',
      oid: this.operator,
      refID: ''
    }
    this.apiData.setSessionData(SessionVar.TransactionRequest, transactionReq);
    if (this.authService.IsAuth()) {
      this.apiData.loadOtherClass();
      this.router.navigate(['redirecttoaction.html'], { queryParams: { reff: '3309a24d426f5ee0d77b91f885ee641b', aid: '538536ff5636f4dc4e894b16182a3165b8413ac0cbabf91126fe2b8be4795f86d3a59a416a6b7b8920d00b0af0109b50' } })
    }
    else {
      this.apiData.loadOtherClass();
      this.router.navigate(['login.html'], { queryParams: { reff: '3309a24d426f5ee0d77b91f885ee641b', pid: '538536ff5636f4dc4e894b16182a3165b8413ac0cbabf91126fe2b8be4795f86d3a59a416a6b7b8920d00b0af0109b50' } });

    }
  }

  GetB2CBanner() {
    const url = this.router.url.replace('/', '').replace('.html', '');
    const serviceId = this.apiData.getRouteID(url);
    var req = { opType: serviceId };
    this.apiService.GetB2CBanner(req).subscribe(resp => {
      if (resp.bannerUrl) {
        this.slides = resp.bannerUrl;
        this.updateView();
      }
    })
  }

  updateView() {
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }
}
